import { FormattedMessage, useIntl } from 'react-intl'
import { BufferMeasure } from '../types'
import { SelectField, MenuItem } from '@carto/meridian-ds/components'

function MeasureDropdown({
  radiusMeasure,
  onChange
}: {
  radiusMeasure: BufferMeasure
  onChange: (event: BufferMeasure) => void
}) {
  const intl = useIntl()

  return (
    <SelectField
      labelId="measure"
      defaultValue={radiusMeasure ? radiusMeasure : 'km'}
      onChange={(event) => onChange(event.target.value as BufferMeasure)}
      aria-label={intl.formatMessage({ id: 'analysis.buffer.measure.unit' })}
    >
      <MenuItem value="m">
        <FormattedMessage id={`analysis.buffer.measure.m`} />
      </MenuItem>
      <MenuItem value="km">
        <FormattedMessage id={`analysis.buffer.measure.km`} />
      </MenuItem>
    </SelectField>
  )
}

export default MeasureDropdown
